(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("UiRichTextEditor", [], factory);
	else if(typeof exports === 'object')
		exports["UiRichTextEditor"] = factory();
	else
		root["UiRichTextEditor"] = factory();
})(window, function() {
return 